import { useEstimatePaymentFee, useDepositState, useDepositActions, useDepositValidation } from "src/hooks";
import { PaymentType } from "src/api";
import { useUrlParamsContext, useDepositWithdrawContext } from "src/contexts";

export const useDeposit = () => {
  // Get context data
  const { balance } = useDepositWithdrawContext();
  const { paymentRouteId } = useUrlParamsContext();
  const { currency } = balance;

  // State management
  const state = useDepositState();
  const { amount, amountTouched, setAmountTouched, initiateDepositLoading, initiateDepositError } = state;

  // Payment fee estimation
  const { paymentFee, paymentFeeLoading, paymentFeeError } = useEstimatePaymentFee({
    paymentType: PaymentType.Deposit,
    amount: Number(amount),
  });

  // Validation
  const { errors } = useDepositValidation({
    amount,
    paymentFeeError,
    paymentFee,
  });

  // Actions
  const actions = useDepositActions({
    amount,
    setAmount: state.setAmount,
    setIsLoading: state.setInitiateDepositLoading,
    setError: state.setInitiateDepositError,
    setSessionData: state.setSessionData,
    currencyPrecision: currency.precision,
    paymentRouteId,
  });

  // Compute submit disabled state
  const submitDisabled =
    paymentFeeLoading ||
    initiateDepositLoading ||
    !!initiateDepositError ||
    Object.values(errors).some((error) => error.length > 0) ||
    !amount;

  return {
    // Amount
    amount,
    amountTouched,
    setAmountTouched,

    // Payment fee
    paymentFee,
    paymentFeeLoading,

    // Currency
    currency,

    // Validation
    errors,
    submitDisabled,

    // Loading and error
    initiateDepositLoading,
    initiateDepositError,

    // Actions
    handleAmountChange: actions.handleAmountChange,
    handleInitiateDeposit: actions.handleInitiateDeposit,
  };
};
